var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.stock-good'),"name":"warehouseStocks","url":_vm.$listRoutes.warehouseStocks.replace(':stage', 'stock'),"table":_vm.warehouseStocks,"filters":_vm.warehouseStocksFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }